// extracted by mini-css-extract-plugin
export default {"Panel":"LocalizedRichTextInput_Panel__h4wju","Tabs":"LocalizedRichTextInput_Tabs__HbPS8","Hidden":"LocalizedRichTextInput_Hidden__pt3Xt"};